import type { ChatSessionsApiResponse } from 'core_main/api/sessions/types';
import {
  PUBNUB_ACCESS_DENIED_CATEGORY,
  PUBNUB_SUBSCRIBE_OPERATION,
} from 'core_main/pubnub/constants';
import { intersection } from 'core_main/globals/helpers';
import type { ConversationCallbackResponse } from '../types';

export const RETRY_MAX = 3;

export const createConversationCallbackResponse = (
  response: ChatSessionsApiResponse,
): ConversationCallbackResponse => {
  const { id: conversationId } = response.data;
  const { createdAt, lockedAt, isInAssistantMode } = response.data.attributes;

  return {
    conversationId,
    createdAt,
    ended: !!lockedAt,
    isInAssistantMode,
  };
};

export const createNewConversationStatusEventListener = (
  { pubnub, conversationChannels },
  cb,
) => {
  let retryCount = 0;
  return (statusEvent) => {
    const { operation, affectedChannels, error, category, errorData } =
      statusEvent;

    if (operation === PUBNUB_SUBSCRIBE_OPERATION) {
      if (
        error &&
        category === PUBNUB_ACCESS_DENIED_CATEGORY &&
        intersection(errorData?.payload?.channels || [], conversationChannels)
          .length > 0 &&
        retryCount < RETRY_MAX
      ) {
        retryCount++;
        setTimeout(() => {
          pubnub.getMetaPubNub()?.instance?.subscribe({
            channels: conversationChannels,
          });
        }, 500);
        return;
      }
      const includedChannels = conversationChannels.filter((channel) =>
        affectedChannels?.includes(channel),
      );
      if (includedChannels.length === conversationChannels.length || error) {
        cb(null, error ? category : null);
      }
    }
  };
};
